<template>
  <div class="wrapper">
    <transition name="slide-fade">
      <left-sidebar></left-sidebar>
    </transition>
    <transition>
      <div id="content">
        <main-header></main-header>
        <transition name="fade" mode="out-in" appear>
          <router-view></router-view>
        </transition>
        <div class="footer-info">
          <div>&copy; ООО «Даобит» {{ new Date().getFullYear() }}</div>
          <div v-if="false"><a target="_blank" href="https://www.daobit.ru/privacy.pdf">Политика обработки персональных данных и реализуемых требований к их защите в ООО «Даобит» (PDF)</a></div>
          <div><span class="mr-2">Frontend-Version: {{ FRONTEND_VERSION }}</span></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LeftSidebar from './LeftSidebar'
import MainHeader from './MainHeader'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'main-container',
  components: {
    LeftSidebar,
    MainHeader
  },
  data () {
    return {
      FRONTEND_VERSION: process.env.VUE_APP_FRONTEND_VERSION
    }
  },
  methods: {
    ...mapActions([
      'loadPackageStatuses',
      'loadDeliveryCodes'
    ]),
    ...mapMutations([
      'hideMenu',
      'displayMenu'
    ])
  },
  computed: {
    ...mapState(
      {
        wait: state => state.wait,
        showMenu: state => state.showMenu,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop
      }
    )
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .slide-fade-enter-active {
    transition: all .3s;
  }

  .slide-fade-leave-active {
    transition: all .1s;
  }

  .slide-fade-enter, .slide-fade-leave-to {
    opacity: 0;
  }

  .wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  #content {
    width: calc(100% - 315px);
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    justify-content: flex-start;
    min-height: 100vh;
    transition: all 0.3s;
    position: relative;
    padding-bottom: 30px;
  }

  #content.active {
    width: 100%;
  }

  .footer-info {
    position: absolute;
    bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    width: 100%;
  }
</style>
